import { render, staticRenderFns } from "./ResubmitCreate.vue?vue&type=template&id=74cc3186&"
import script from "./ResubmitCreate.vue?vue&type=script&lang=js&"
export * from "./ResubmitCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports